type RestErrorDetails = Record<string, unknown>;

export class RestError {
  constructor(
    public readonly message: string,
    public readonly error: string,
    public readonly statusCode: number,
    public readonly details?: RestErrorDetails
  ) {
    if (details) {
      this.details = this.pickAllowedDetails(details);
    }
  }

  private pickAllowedDetails(details: RestErrorDetails): RestErrorDetails {
    // Only the structured payloads the UI acts on. "fieldErrors" carries per-field validation
    // failures (see the draft validate/finalize branches of GlobalExceptionFilter).
    // "affectedCount"/"compatibleUnits"/"incompatibleUnits" carry the bulk-edit EF/unit
    // mismatch breakdown (BulkEmissionFactorUnitMismatchException).
    const ALLOWED_DETAILS_KEYS = [
      "sections",
      "type",
      "fieldErrors",
      "code",
      "affectedCount",
      "compatibleUnits",
      "incompatibleUnits",
    ];

    return Object.keys(details).reduce((acc, key) => {
      if (ALLOWED_DETAILS_KEYS.includes(key)) {
        acc[key] = details[key];
      }
      return acc;
    }, {} as RestErrorDetails);
  }
}
